// extracted by mini-css-extract-plugin
export default {"avatar":"VW1Ux4","withBorder":"pWdmft","filter":"fJQOlE"};